<template>
  <div class="alert-select-list-container" :style="containerStyle">
    <v-select
      class="alert-select-list-control"
      :items="sortedAlerts"
      item-text="display"
      item-value="id"
      v-model="selectedAlerts"
      :placeholder="controlLabel"
      :menu-props="menuprops"
      outlined
      multiple
      return-object
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0"> {{ selectedAlerts.length }} Alerts </span>
      </template>
    </v-select>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashOrderBy from "lodash/orderBy";
import lodashDebounce from "lodash/debounce";
import lodashForEach from "lodash/forEach";
import { mapGetters } from "vuex";
import {
  MODULE_PREFIX_ALERTS,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_HOME,
} from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "ContentAlertFilter",
  props: {
    value: {
      type: Array,
    },
    isIndependent: {
      type: Boolean,
    },
    defaultLabel: {
      type: String,
      default: "My Alerts",
    },
    width: {
      type: String,
      default: "110",
    },
    filterCounts: {
      type: Array,
    },
  },
  created() {
    this.getPrefs();
  },
  data() {
    return {
      selectedAlerts: [],
      menuprops: {
        left: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      alerts: MODULE_PREFIX_ALERTS + "alerts",
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    controlLabel() {
      return this.selectedAlerts && this.selectedAlerts.length === 0
        ? this.defaultLabel
        : "";
    },
    sortedAlerts() {
      if (this.alerts && Array.isArray(this.alerts)) {
        let alerts = this.alerts;

        if (this.filterCounts && this.isAlertFilterCountUnlocked) {
          if (this.selectedAlerts.length === 0) {
            // AAAS-2489 Static counts
            lodashForEach(alerts, (alert) => {
              let id = alert.id.replaceAll("-", "");
              let obj = lodashFind(this.filterCounts, { alertId: id });
              alert["count"] = obj ? obj.count : 0;
              alert["display"] = alert.name + " (" + alert.count + ")";
            });
          }

          return lodashOrderBy(alerts, ["count"], ["desc"]);
        } else {
          lodashForEach(alerts, (alert) => {
            alert["display"] = alert.name;
          });

          return lodashOrderBy(alerts, ["display"], ["asc"]);
        }
      }
      return null;
    },
    containerStyle() {
      return {
        width: `${this.width}px`,
      };
    },
  },
  methods: {
    isValid(temp) {
      let results = [];
      for (let i = 0; i < this.alerts.length; i++) {
        for (let j = 0; j < temp.length; j++) {
          if (this.alerts[i].id === temp[j].id) {
            results.push(temp[j]);
          }
        }
      }
      return results;
    },
    async savePrefs() {
      if (this.preferences.alerts && this.preferences.alerts.content) {
        let cleanAlerts = [];
        this.selectedAlerts.forEach((alert) => {
          cleanAlerts.push({
            id: alert.id,
            name: alert.name,
          });
        });
        this.preferences.alerts.content.alertFilter = cleanAlerts;
        await this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          this.preferences
        );
      }
    },
    getPrefs() {
      if (!this.isIndependent) {
        const alertFilter = lodashGet(
          this.preferences,
          "alerts.content.alertFilter"
        );
        if (alertFilter && alertFilter.length > 0) {
          this.selectedAlerts = this.isValid(alertFilter);
        } else {
          this.selectedAlerts = [];
        }
      }

      // selectedData may contain a specific alertid
      if (lodashGet(this.selectorPanel, "selectedData.alertId")) {
        this.selectedAlerts = [];
        const ALERT = lodashFind(this.alerts, (obj) => {
          return obj.id === this.selectorPanel.selectedData.alertId;
        });
        if (ALERT) {
          this.selectedAlerts.push(ALERT);
        }
      }
    },
    isAlertFilterCountUnlocked() {
      return this.featureUnlocked("alert-filter-count-watch");
    },
  },
  watch: {
    selectedAlerts: lodashDebounce(function (newVal, oldVal) {
      if (this.isIndependent) {
        this.$emit("callback", {
          field: "alertFilters",
          data: this.selectedAlerts,
        });
      } else {
        this.savePrefs();
      }

      if (newVal.length > oldVal.length) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.alerted_content,
          EVENT_ACTIONS.enabled,
          "Explore Content - Alert Filter"
        );
      }
    }, 500),
    alerts() {
      this.getPrefs();
    },
  },
};
</script>

<style scoped>
.alert-select-list-control >>> .v-input__control {
  height: 35px !important;
}
.alert-select-list-container {
  padding: 5px 5px 0 0;
}
.alert-select-list-control >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: auto !important;
}
.alert-select-list-control >>> .v-label {
  top: auto;
  color: #646464;
}
.alert-select-list-control >>> .v-input__append-inner {
  display: none;
}
.alert-select-list-control >>> .v-select__selections {
  padding: 0 !important;
}
.alert-select-list-control >>> .v-select__selection {
  color: #646464;
}
</style>
